import { useMutation } from '@tanstack/react-query'
import { aiStudioService } from '../../../service/aiStudio'

function useDeleteSynthesisJob() {
  return useMutation({
    mutationKey: ['delete-synthesis-job'],
    mutationFn: (jobId: number) => aiStudioService.deleteSynthesisJob(jobId),
  })
}

export default useDeleteSynthesisJob